import { SearchPage } from './entities'

import { getStoryBySlug } from "../story/requests";

const getSearchResultsPage = () => getStoryBySlug("search").then(SearchPage)

export { getSearchResultsPage};
